export default __webpack_public_path__ + "2d26f29ba134ab1b852674bf7d64483c.png";